import { Routes } from '@angular/router';

/**
 * `flogin` es SOLO el login central: el login y el restablecimiento.
 *
 * **No hay `invitadoGuard` en `login`, y la ausencia es deliberada.** En un
 * frontend con pantallas propias ese guard saca del login a quien ya tiene
 * sesion. Aqui estar autenticado **sin acceso elegido** es precisamente el
 * estado en el que hay que SEGUIR en esta pantalla, porque es donde se pinta la
 * rejilla de accesos. Con el guard puesto, autenticarse expulsaria al usuario de
 * la unica pantalla capaz de mostrarle sus accesos.
 *
 * El dia que el login gane una pantalla propia con sesion viva —un perfil, las
 * sesiones activas— esa ruta si lleva `sesionGuard`, que sigue exportado en
 * `@auth`.
 */
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    /**
     * Elegir contraseña nueva con el token que llego por correo.
     *
     * ── POR QUE ES RUTA Y NO UNA CUARTA VISTA DEL LOGIN ───────────────────
     *
     * Las tres vistas del login se DERIVAN del estado de sesion, y aqui no hay
     * ninguna: se llega desde un enlace de correo. Meterla alli obligaria a un
     * cuarto estado que no sale de la sesion sino de un parametro de la URL, y
     * la regla de esa pantalla —«la vista se deriva, no se cambia a mano»—
     * dejaria de ser cierta para un caso.
     *
     * SIN guard, y es deliberado: quien llega aqui NO tiene sesion, que es
     * justo el motivo de estar aqui. Tampoco `invitadoGuard`: alguien con sesion
     * abierta en otra pestaña tiene el mismo derecho a usar su enlace.
     *
     * La ruta es parte de un CONTRATO con el backend: el correo la construye
     * desde `Correo:UrlRestablecer`. Cambiarla rompe los enlaces ya enviados y
     * los que se manden hasta que alguien actualice esa configuracion.
     */
    path: 'restablecer',
    loadComponent: () =>
      import('./pages/restablecer/restablecer.page').then((m) => m.RestablecerPage),
  },
  {
    // Todo cae al login. No se pierde el `volverA`: el router conserva los query
    // params en una redireccion de ruta.
    path: '**',
    redirectTo: 'login',
  },
];
